import { Row, Col, Label, Input, FormGroup } from "reactstrap";

import { Checkbox } from "components/Input";
import typography from "../typography";
import trashIcon from "assets/images/app/common/trash-icon.svg";
import plusIcon from "assets/images/app/common/plus-icon.svg";

export default function QuestionRow({
    question,
    index,
    disabled = false,
    errors = {},
    touched = {},
    onChange = () => {},
    onRemove = () => {},
    onAddOption = () => {},
    onOptionChange = () => {},
    onRemoveOption = () => {},
    canRemove = true,
}) {
    const questionErrors = errors?.questions?.[index] || {};
    const questionTouched = touched?.questions?.[index] || {};

    return (
        <div className="feedback-question-row mb-4 p-3">
            <Row className="align-items-start">
                <Col md="7">
                    <FormGroup>
                        <Label>{typography.QUESTION} {index + 1}</Label>
                        <Input
                            type="text"
                            value={question.content}
                            disabled={disabled}
                            onChange={(e) => onChange(index, "content", e.target.value)}
                            invalid={!!(questionTouched.content && questionErrors.content)}
                        />
                        {questionTouched.content && questionErrors.content && (
                            <div className="invalid-feedback d-block">
                                {questionErrors.content}
                            </div>
                        )}
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>{typography.QUESTION_TYPE}</Label>
                        <Input
                            type="select"
                            value={question.type}
                            disabled={disabled}
                            onChange={(e) => onChange(index, "type", e.target.value)}
                        >
                            <option value="TEXT">{typography.TEXT_ANSWER}</option>
                            <option value="NUMBER">{typography.NUMBER_ANSWER}</option>
                            <option value="OPTIONS">{typography.OPTIONS_ANSWER}</option>
                        </Input>
                    </FormGroup>
                </Col>
                <Col md="2" className="d-flex flex-column justify-content-between h-100">
                    <Checkbox
                        id={`required-${index}`}
                        title={typography.REQUIRED}
                        checked={question.requiredField}
                        onChange={(e) => onChange(index, "requiredField", e.target.checked)}
                        withMargin={false}
                        classes={disabled ? "disabled" : ""}
                    />
                    {canRemove && !disabled && (
                        <div
                            role="button"
                            className="feedback-question-remove mt-2"
                            onClick={() => onRemove(index)}
                        >
                            <img src={trashIcon} alt="remove question" /> {typography.REMOVE}
                        </div>
                    )}
                </Col>
            </Row>

            {question.type === "OPTIONS" && (
                <div className="feedback-options-con mt-2">
                    {question.answerOptions.map((option, optionIndex) => (
                        <Row key={optionIndex} className="align-items-center mb-2">
                            <Col md="7">
                                <Input
                                    type="text"
                                    placeholder={`${typography.OPTION} ${optionIndex + 1}`}
                                    value={option.content}
                                    disabled={disabled}
                                    onChange={(e) =>
                                        onOptionChange(index, optionIndex, e.target.value)
                                    }
                                />
                            </Col>
                            {!disabled && question.answerOptions.length > 1 && (
                                <Col md="1">
                                    <img
                                        src={trashIcon}
                                        alt="remove option"
                                        role="button"
                                        onClick={() => onRemoveOption(index, optionIndex)}
                                    />
                                </Col>
                            )}
                        </Row>
                    ))}
                    {questionTouched.answerOptions && questionErrors.answerOptions && (
                        <div className="invalid-feedback d-block">
                            {typeof questionErrors.answerOptions === "string"
                                ? questionErrors.answerOptions
                                : ""}
                        </div>
                    )}
                    {!disabled && (
                        <div
                            role="button"
                            className="feedback-add-option"
                            onClick={() => onAddOption(index)}
                        >
                            <img src={plusIcon} alt="add option" /> {typography.ADD_OPTION}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
